import { render } from "./projectDetail.vue?vue&type=template&id=2e407bbd&ts=true"
import script from "./projectDetail.vue?vue&type=script&lang=ts"
export * from "./projectDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__